import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface DocumentItem {
  id: string;
  [key: string]: any;
}

interface DocumentsState {
  items: DocumentItem[];
  loading: boolean;
  error: string | null;
}

const initialState: DocumentsState = {
  items: [],
  loading: false,
  error: null,
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    // Other actions can be added here if needed
  },
  extraReducers: (builder) => {
    // Handle data from GET_BOOKINGS_COMMIT
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      documents?: DocumentItem[];
      bookings?: any[];
      [key: string]: any;
    }>) => {
      const { documents } = action.payload;
      const { meta } = action as any;

      const isPagedRequest = meta && meta.page !== undefined && meta.page > 0;

      if (isPagedRequest) {
        if (documents && documents.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, documents);
        }
      } else {
        // First page load or refresh - replace all documents
        state.items = documents || [];
      }
    });
  },
});

export const {
  // Actions will be exported here if needed
} = documentsSlice.actions;

export default documentsSlice.reducer;